import React from 'react';
import { useTheme } from 'styled-components/macro';

import useDependencies from '../Hooks/useDependencies';
import { Button } from '../SubComponents/Buttons';
import { hexToRgb } from '../Utils/utils';
import { errorReducerActionTypes } from '../redusers/error-reducer';

interface SummaryMobileConfirmButtonProps {
  dependencies: {
    key: string;
    value: any;
    clickable?: boolean;
    errorType?: errorReducerActionTypes;
  }[];
  onClick: () => void;
  onError?: (errorType: errorReducerActionTypes) => void;
  enabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
}

const SummaryMobileConfirmButton = ({
  children,
  dependencies,
  onClick,
  onError,
  enabled = true,
  loading,
}: SummaryMobileConfirmButtonProps) => {
  const { checkDependencies, isDisabled, isVisuallyDisabled } =
    useDependencies(dependencies);
  const theme = useTheme();

  const handleClick = () => {
    checkDependencies()
      .then(() => onClick())
      .catch((dependency) => onError && onError(dependency.errorType));
  };

  return (
    <Button
      id="step4NextButton"
      loading={loading}
      onClick={handleClick}
      disabled={!enabled || isDisabled || loading}
      className={isVisuallyDisabled ? 'disabled' : undefined}
      width="100%"
      color={theme.textColor}
      bg={theme.highLightColor}
      disabledColor={hexToRgb(theme.highLightColor, { opacity: 30 })}
    >
      {children}
    </Button>
  );
};

export default SummaryMobileConfirmButton;
